module.exports = __webpack_public_path__ + "static/img/h1.c5a7822.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/h1.gif
// module id = 5tcJ
// module chunks = 1